import { Heading, Text } from '@chakra-ui/react';
import Page from '@inspire/ui/chakra/layout/Page';

import Link from 'components/general/Link';
import Layout from 'components/layout/Layout';

const MentionsLegalesPage = () => (
  <Page title="Mentions légales d’INSPIRE" withPanel headingIsTitle>
    <Heading size="md" mt={8}>
      Ce site est édité par Article 1
    </Heading>
    <Text>Association d’intérêt général</Text>
    <Text>N° de Siren : 499 381 812</Text>
    <Text>29 Boulevard Bourdon, 75004 Paris</Text>
    <Text>
      Site internet :{' '}
      <Link href="https://www.article-1.eu" target="_blank">
        www.article-1.eu
      </Link>
    </Text>
    <Text>
      <b>Directeur de la publication : M. Benjamin Blavier</b>
    </Text>
    <Heading size="md" mt={8}>
      Partenariats
    </Heading>
    <Text>
      <Link href="https://www.parcoursup.fr/" target="_blank">
        Parcoursup
      </Link>
    </Text>
    <Text>
      <Link href="https://www.onisep.fr/" target="_blank">
        Onisep
      </Link>
    </Text>
    <Heading size="md" mt={8}>
      Financement
    </Heading>
    <Text>Caisse des Dépôts et Consignations</Text>
    <Text>Fondation Alpha Omega</Text>
    <Heading size="md" mt={8}>
      Contribution
    </Heading>
    <Text>Probably Optimized, Lda</Text>
    <Text>Wexperience</Text>
    <Text>Aub-learning</Text>
    <Text>Peetch</Text>
    <Text>Atrioom</Text>
    <Text>Lauriane Albrecht</Text>
    <Text>Wilbi</Text>
    <Text>Association Nationale des Apprentis de France</Text>
    <Text>Entreprendre pour apprendre</Text>
    <Text>Sylvain Nouhi</Text>
    <Heading size="md" mt={8}>
      Témoignages
    </Heading>
    <Text>Véronique Lugiéry, Transdev</Text>
    <Text>Julien Ridé, Page Personnel </Text>
    <Text>Imtinen Abidi</Text>
    <Text>Océane Cano</Text>
    <Text>Cheikh Diasse</Text>
    <Text>Amara Kébé</Text>
    <Text>Nassim Merzouk</Text>
    <Text>Mariam Mohamed</Text>
    <Text>Taysir Sellami</Text>
    <Heading size="md" mt={8}>
      Ce site est développé par Improba
    </Heading>
    <Text>128 Rue La Boétie 75008 Paris</Text>
    <Text>Site internet :</Text>
    <Text>
      <Link href="https://improba.fr/" target="_blank">
        https://improba.fr/
      </Link>
    </Text>

    <Heading size="md" mt={8}>
      Ce site est hébergé par AdmanTIC
    </Heading>
    <Text>
      12 Av. des Prés, 78180 Montigny-le-Bretonneux
      <br />
      Site Internet :<br />
      <Link href="https://www.admantic.fr/" target="_blank">
        https://www.admantic.fr/
      </Link>
      <br />
      Sur des serveurs hébergés en France par la société MOJI - 9 rue des
      Pavillons 92000 Nanterre
    </Text>
  </Page>
);

MentionsLegalesPage.getWrappers = (page) => (
  <Layout
    variant="adaptative"
    rowProps={{ variant: 'gray' }}
    containerWidth="lg"
  >
    {page}
  </Layout>
);

export default MentionsLegalesPage;
